import * as React from 'react';
import { ReactNode } from 'react';
import { useTranslation } from 'next-i18next';
import { cn } from '@restworld/utils-common';
/* eslint-disable-next-line */
export interface ImpressionIllustrationProps {
  children: ReactNode;
  variant?: 'mobileImageOverlay' | 'imageOverlay';
}

export function ImpressionIllustration({ children, variant }: ImpressionIllustrationProps) {
  const { t } = useTranslation('common');

  return variant === 'mobileImageOverlay' ? (
    <MobileImageOverlay>
      {children}
      <div className="flex top-0 left-0 w-full h-full absolute">
        <StickNote styles={['absolute top-3 left-[64%]  bg-primary-800 text-white -rotate-9']}>receptionist</StickNote>
        <StickNote
          styles={['absolute top-13 left-4.25 bg-secondary-700 border border-secondary-700 text-black rotate-8.5']}
        >
          chef
        </StickNote>
        <StickNote
          styles={['absolute bottom-17.75 left-11.25 bg-white border border-primary-800 text-black -rotate-8.69']}
        >
          {t('impression_illustration_waiter')}
        </StickNote>
        <StickNote
          styles={[
            'absolute bottom-3.75 right-2.75 bg-secondary-700 border border-secondary-700 text-black rotate-8.5',
          ]}
        >
          manager
        </StickNote>
      </div>
    </MobileImageOverlay>
  ) : (
    <ImageOverlay>
      {children}
      <div className="flex top-0 left-0 w-full h-full relative">
        <StickNote styles={['absolute top-25 left-70.75 bg-primary-800 text-white -rotate-9']}>receptionist</StickNote>
        <StickNote
          styles={['absolute top-54 -left-5.5 bg-secondary-700 border border-secondary-700 text-black rotate-8.5']}
        >
          chef
        </StickNote>
        <StickNote
          styles={['absolute bottom-84.5 left-21.5 bg-white border border-primary-800 text-black -rotate-8.69']}
        >
          {t('impression_illustration_waiter')}
        </StickNote>
        <StickNote
          styles={[
            'absolute bottom-52.5 right-24.5 bg-secondary-700 border border-secondary-700 text-black rotate-8.5',
          ]}
        >
          manager
        </StickNote>
      </div>
    </ImageOverlay>
  );
}

export default ImpressionIllustration;

const MobileImageOverlay = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('bg-transparent z-[9] relative flex w-full h-full', className)} {...props} />
);

const ImageOverlay = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('bg-transparent z-[9] absolute top-0 left-0 flex h-full w-full', className)} {...props} />
);

const StickNote = ({ styles, className, ...props }: any) => (
  <div
    className={cn('lg:px-4 lg:py-1 px-2 py-0.5 rounded-2.5 font-medium lg:text-xl text-sm leading-7.5', className)}
    {...props}
  />
);
